import actionTypes from 'SRC/modules/redux/actionTypes'

export const setServiceTypesLoading = isLoading => ({
  type: actionTypes.SET_SERVICE_TYPES_LOADING,
  payload: Boolean(isLoading)
})
